import { UserInformation, type UserInformationUser } from "@synthesis/shared-ui";
import { cn } from "@synthesis/shared-utils";

const parseFullName = (fullName: string): Pick<UserInformationUser, "firstName" | "lastName" | "middleName"> => {
  const [lastName, firstName, ...middleNameParts] = fullName.trim().split(/\s+/).filter(Boolean);

  return {
    lastName,
    firstName,
    middleName: middleNameParts.length > 0 ? middleNameParts.join(" ") : undefined,
  };
};

export const buildUserFromFullName = (fullName: string, email?: string | null): UserInformationUser => ({
  ...parseFullName(fullName),
  email: email ?? undefined,
});

type UserNameInformationProps = {
  name: string;
  email?: string | null;
  triggerClassName?: string;
  className?: string;
};

export const UserNameInformation = ({ name, email, triggerClassName, className }: UserNameInformationProps) => {
  if (name === "—") {
    return <span className={triggerClassName}>{name}</span>;
  }

  return (
    <UserInformation
      start
      inlineBlock
      className={cn("mt-0", className)}
      trigger={<span className={triggerClassName}>{name}</span>}
      user={buildUserFromFullName(name, email)}
    />
  );
};
